//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/DesignSimulation.js";
import "../no/NXObject.js";
let d=[[],[[["nMembers","members"],"GetMembers",{},0,0],[["source","target","type"],"Reorder",{},3,0]],[]];
SPLM.DesignSimulation.Container = class extends SPLM.NXObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.DesignSimulation.Container";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.DesignSimulation.Container.ReorderType = Object.freeze({
    "Before" : "Before", "After" : "After", "Into" : "Into"});

export default SPLM;